import { render } from 'preact';
import Navigation from '../navigation/Navigation';

/** Dev-only: connects to Preact DevTools extension (omit from production bundle). */
if (import.meta.env.DEV) {
  import('preact/devtools').catch(() => {});
}

const rootElement = document.getElementById('spyscape-shared-nav');
const navElement = document.createElement('nav');
const { contentId, apiHost = '', alternateNavbarTheme } = rootElement.dataset;
rootElement.appendChild(navElement);

const init = () => {
  render(
    <Navigation
      contentId={contentId}
      apiHost={apiHost}
      alternateNavbarTheme={alternateNavbarTheme !== undefined}
    />,
    navElement,
  );
};

init();

if (import.meta.hot) {
  import.meta.hot.accept('../navigation/Navigation', init);
}
